import { ExpenseKindEnum, type Tax } from "@finway-group/shared/lib/models"
import { getDefaultTaxRateObject } from "~Shared/utils/helper.utils"
import { NO_TAX_RATE } from "../config/consts"

export const getInitialTaxRate = ({ taxes, kind, isSelfIssuedReceipt = false }: { taxes: Array<Tax>; kind: ExpenseKindEnum; isSelfIssuedReceipt?: boolean }) => {
    if (isSelfIssuedReceipt) {
        return { _id: NO_TAX_RATE }
    }
    const defaultTax = getDefaultTaxRateObject(taxes)
    if (kind === ExpenseKindEnum.HOSPITALITY) {
        return defaultTax.taxRate === 0 ? defaultTax : { _id: NO_TAX_RATE }
    }
    return defaultTax
}

/** Self-issued receipts cannot claim input tax, so their items must start without a VAT rate. */
export const getInitialSplitTaxRate = ({ taxes, isSelfIssuedReceipt = false }: { taxes: Array<Tax>; isSelfIssuedReceipt?: boolean }): Tax | { _id: string } =>
    isSelfIssuedReceipt ? { _id: NO_TAX_RATE } : getDefaultTaxRateObject(taxes)
